import Button from '@material-ui/core/Button';
import styled, { css } from 'styled-components';

interface RoundedButtonProps {
    size?: 'normal' | 'large';
}

export const RoundedButton = styled(Button)<RoundedButtonProps>`
    padding: 8px 24px;
    border-radius: 24px;

    ${props =>
        props.size === 'large' &&
        css`
            padding: 8px 60px;
        `}
`;
